import { getVehicleUseFunction } from '@/common/queries/selections/vehicleUse/vehicleUseFunction';
import { InsuranceABV } from '@/common/types/SelectionOptions.type';
import { queryOptions } from '@tanstack/react-query';

export const vehicleUseOption = ({
  insurance,
  type,
}: {
  insurance: InsuranceABV;
  type: string;
}) =>
  queryOptions({
    queryKey: ['get_vehicle_use', insurance, type],
    queryFn: () => getVehicleUseFunction({ insurance, type }),
  });
